import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-icons-tuiles',
    templateUrl: './icons-tuiles.component.html',
    styleUrls: ['./icons-tuiles.component.css'],
    standalone: false
})
export class IconsTuilesComponent implements OnInit {
  @Input() icon;
  // color = '#376194';
  color = '#376194';
  silver = '#c0c0c0';

  constructor() { }

  ngOnInit() {
  }

}
